import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { ChangeStatus } from '../../../../shared/issuesV2';
import { useQuery } from '../../../contexts/RouterContext';
import { useOnMount } from '../../../hooks';
import * as IssuesV2Store from '../../../redux/issuesV2';
import SidebarNavLayout from '../../layouts/SidebarNavLayout';
import IssuesInbox from '../IssuesInbox';
import useFetchIssuesAction from '../IssuesInbox/hooks/useFetchIssuesAction';
import type { IssuesContainerProps } from '../IssuesContainer';

const ComparisonContent: VoidFunctionComponent<IssuesContainerProps> = ({
  params,
  location,
  project,
  revision,
  router,
}) => {
  const changeStatus = useSelector(IssuesV2Store.selectors.getChangeStatus) as ChangeStatus;

  const setChangeStatus = useFetchIssuesAction(IssuesV2Store.actions.setComparisonChangeStatus);

  const [urlChangeStatus] = useQuery<{ scope: { compareTo: { changeStatus: ChangeStatus } } }>(
    (query) => ({
      scope: {
        compareTo: {
          changeStatus: query?.scope?.compareTo?.changeStatus,
        },
      },
    }),
  );

  useOnMount(() => {
    if (urlChangeStatus?.scope?.compareTo?.changeStatus) {
      setChangeStatus(urlChangeStatus.scope.compareTo.changeStatus);
    }
  });

  return (
    <SidebarNavLayout>
      <SidebarNavLayout.Nav>
        <SidebarNavLayout.NavHeading>
          Issues
        </SidebarNavLayout.NavHeading>
        <SidebarNavLayout.Nav.Item
          to="#"
          onClick={(e) => {
            e.preventDefault();
            setChangeStatus(ChangeStatus.New);
          }}
          isActive={changeStatus === ChangeStatus.New}>
          New
        </SidebarNavLayout.Nav.Item>
        <SidebarNavLayout.Nav.Item
          to="#"
          onClick={(e) => {
            e.preventDefault();
            setChangeStatus(ChangeStatus.Remediated);
          }}
          isActive={changeStatus === ChangeStatus.Remediated}>
          Remediated
        </SidebarNavLayout.Nav.Item>
        <SidebarNavLayout.NavItem
          to="#"
          onClick={(e) => {
            e.preventDefault();
            setChangeStatus(ChangeStatus.Unchanged);
          }}
          isActive={changeStatus === ChangeStatus.Unchanged}>
          Unchanged
        </SidebarNavLayout.NavItem>
      </SidebarNavLayout.Nav>
      <SidebarNavLayout.Content>
        <IssuesInbox params={params} location={location} project={project} revision={revision} router={router} />
      </SidebarNavLayout.Content>
    </SidebarNavLayout>
  );
};

export default ComparisonContent;
